import { useState } from 'react';
import { useBrand } from '../providers/BrandProvider';

interface BrandLogoProps {
  variant: 'sidebar' | 'login' | 'mobile' | 'login-dark';
  className?: string;
}

const sizeMap = {
  sidebar: 'h-8',
  mobile: 'h-7',
  login: 'h-16',
  'login-dark': 'h-14',
} as const;

export default function BrandLogo({ variant, className = '' }: BrandLogoProps) {
  const brand = useBrand();
  const [imgError, setImgError] = useState(false);
  const isDark = variant === 'login-dark';
  const src = isDark ? brand.logoDarkUrl : brand.logoUrl;
  const heightClass = sizeMap[variant];

  if (imgError || !src) {
    const initial = brand.productName.charAt(0).toUpperCase();
    const size = variant === 'login' || variant === 'login-dark' ? 'w-14 h-14 text-2xl' : 'w-8 h-8 text-sm';
    return (
      <div className={`${size} rounded-xl flex items-center justify-center shadow-card font-bold font-display text-white ${className}`}
           style={{ background: `linear-gradient(135deg, var(--brand-primary-500), var(--brand-primary-700))` }}>
        {initial}
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={brand.productName}
      className={`${heightClass} w-auto object-contain ${className}`}
      onError={() => setImgError(true)}
    />
  );
}
